<template>
	<MobHomeFlowCore>
		<template #banner>
			<div
				v-if="getBackgroundImage"
				class="m-home-banner"
				:style="{ backgroundImage: `url(${getBackgroundImage})` }"
			></div>
		</template>
	</MobHomeFlowCore>
</template>

<script setup>
import { useCommonData } from '@/hooks';
import MobHomeFlowCore from './MobHomeFlowCore.vue';

const { getBackgroundImage } = useCommonData();
</script>

<style lang="less" scoped>
.m-home-banner {
	height: 120px;
	background-size: cover;
	background-position: center center;
	background-repeat: no-repeat;
}
</style>
